module.exports = __webpack_public_path__ + "img/messages.028708b9.svg";